import React, { useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { DiscoveryPage } from './pages/DiscoveryPage';
import { AskPage } from './pages/AskPage';
import { DepositionPage } from './pages/DepositionPage';
export function App() {
  const [activePage, setActivePage] = useState<'discovery' | 'ask' | 'deposition'>('discovery');
  return <div className="flex h-screen w-screen overflow-hidden bg-navy text-text-primary font-sans selection:bg-accent-amber/30 selection:text-white" data-id="element-0">
      <Sidebar activePage={activePage} setActivePage={setActivePage} data-id="element-1" />

      <main className="flex-1 flex flex-col min-w-0 overflow-hidden relative" data-id="element-2">
        {activePage === 'discovery' && <DiscoveryPage data-id="element-3" />}
        {activePage === 'ask' && <AskPage data-id="element-4" />}
        {activePage === 'deposition' && <DepositionPage data-id="element-5" />}
      </main>
    </div>;
}